(ns app.front.view.group.admin.inspections.time-slots-editor
  (:require [app.domain.booking.model :as booking-model]
            [app.domain.inspection.model :as inspection-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.inspections.booking-utils :as butil]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-fx ::save-time-slots
  (fn [{:keys [db]} [_ authority-group-id]]
    (let [{:availability/keys [time-slots customer-time-slots]
           ::keys             [separate-cust-slots?]}          (::editor db)]
      {:comm/command {:command    :inspection/set-time-slots
                      :data       (merge {:availability/time-slots time-slots
                                          :group-id                authority-group-id}
                                         (when (and separate-cust-slots? (seq customer-time-slots))
                                           {:availability/customer-time-slots customer-time-slots}))
                      :on-success [::save-time-slots.success]
                      :notify     {:success :inspection/time-slots-saved}}})))


(rf/reg-event-fx ::save-time-slots.success
  (fn [{:keys [db]} [_ status response]]
    {:db       (dissoc db ::editor)
     :dispatch [::entities/apply-changes status response]}))


(rf/reg-sub ::dispatch-time-slots
  :<- [::gas/group-availability]
  :-> (partial booking-model/distinct-time-slot-times :availability/time-slots))


(rf/reg-sub ::customer-time-slots
  :<- [::gas/group-availability]
  :-> (partial booking-model/distinct-time-slot-times :availability/customer-time-slots))


(rf/reg-sub ::editing?
  (fn [db _]
    (-> db ::editor seq boolean)))


(rf/reg-event-db ::set-editor-value
  (fn [db [_ k v]]
    (assoc-in db [::editor k] v)))


(rf/reg-event-db ::clear-editor
  (fn [db _]
    (dissoc db ::editor)))


(rf/reg-sub ::editor :-> ::editor)


(rf/reg-sub ::editor-value
  :<- [::editor]
  (fn [editor [_ k]]
    (get editor k)))


(rf/reg-sub ::slots-edited?
  :<- [::dispatch-time-slots]
  :<- [::customer-time-slots]
  :<- [::editor-value :availability/time-slots]
  :<- [::editor-value :availability/customer-time-slots]
  :<- [::editor-value ::separate-cust-slots?]
  (fn [[dispatch-slots customer-slots editor-dispatch-slots editor-customer-slots separate-cust-slots?] _]
    (or (not= dispatch-slots editor-dispatch-slots)
        (not= (not-empty customer-slots) (not-empty editor-customer-slots))
        (and (seq customer-slots) (not separate-cust-slots?)))))


(rf/reg-sub ::slots-valid?
  :<- [::editor-value :availability/time-slots]
  :<- [::editor-value :availability/customer-time-slots]
  (fn [[editor-dispatch-slots editor-customer-slots] _]
    (and (seq editor-dispatch-slots)
         (inspection-model/validate-time-slots editor-dispatch-slots)
         (or (empty? editor-customer-slots)
             (inspection-model/validate-time-slots editor-customer-slots)))))


(defn time-slot-editor [{:keys                                                           [tr i can-remove? on-change on-remove]
                         {:time-slot/keys [start-hour start-minute end-hour end-minute]} :slot}]
  (let [invalid? (not (inspection-model/validate-time-slot start-hour start-minute end-hour end-minute))]
    [:div.flex.flex-wrap.w-full.mb-6
     [:label.bx--label.block (tr [:inspection/time-slot] [(inc i)])]
     [:div.flex.flex-wrap.w-full.items-start
      [:div.inline-block
       [ui/time-input {:id           (str "admin-time-slot-start-" i)
                       :on-change    (fn [[h m]]
                                       (on-change i (p/assoc-if {}
                                                                :time-slot/start-hour h
                                                                :time-slot/start-minute m)))
                       :value        [start-hour start-minute]
                       :min-step     10
                       :invalid?     invalid?
                       :invalid-text (when invalid? (tr [:inspection/time-slot-invalid]))}]]
      [:div.inline-block.flex.items-center.justify-center.ml-2.mr-2
       [:span "-"]]
      [:div.inline-block
       [ui/time-input {:id        (str "admin-time-slot-end-" i)
                       :on-change (fn [[h m]]
                                    (on-change i (p/assoc-if {}
                                                             :time-slot/end-hour h
                                                             :time-slot/end-minute m)))
                       :value     [end-hour end-minute]
                       :min-step  10}]]
      [ui/modal-confirmation-button
       {:id                  (str "remove-time-slot-" i)
        :tr                  tr
        :trigger-button-opts {:kind       :primary
                              :class-name "ml-4"
                              :disabled   (not can-remove?)
                              :size       :field}
        :trigger-button-text (tr [:remove])
        :on-yes-click        #(on-remove i)}
       (tr [:inspection/remove-time-slot-confirm])]]]))


(defn time-slots-editor [{:keys [tr group-id]} attr]
  (let [editor-slots (<sub [::editor-value attr])
        on-change    (fn [i new-val-map]
                       (rf/dispatch-sync [::set-editor-value attr
                                          (let [[before after] (split-at i editor-slots)]
                                            (vec (concat before
                                                         [(merge (first after) new-val-map)]
                                                         (rest after))))]))
        on-remove    (fn [i]
                       (>evt [::set-editor-value attr
                              (let [[before after] (split-at i editor-slots)]
                                (vec (concat before (rest after))))]))]
    [:div.flex.flex-wrap.w-full
     (for-frag [[i slot] (map-indexed vector editor-slots)
                :let [can-remove? (or (not= attr :availability/time-slots)
                                      (some? (next editor-slots)))]]
       ^{:key (str "time-slot-" i)}
       [:div {:data-cy "single-time-slot-editor"}
        [time-slot-editor (util/mmap can-remove? tr i slot group-id on-change on-remove)]])
     (cc/button
       {:class-name "mt-2"
        :kind       :tertiary
        :size       :field
        :on-click   #(>evt [::set-editor-value attr
                            (concat editor-slots
                                    [{:time-slot/start-hour   12
                                      :time-slot/start-minute 0
                                      :time-slot/end-hour     16
                                      :time-slot/end-minute   0}])])}
       (tr [:add]))]))


(defn time-slot-list [{:keys [tr group-tz]} slots]
  [:div.flex.flex-wrap.w-full.items-start
   [:div.w-64
    (map-indexed (fn [i slot] [:div {:class   (when (> i 0) "mt-2")
                                     :key     (str "time-slot-" i)
                                     :data-cy "single-time-slot"}
                               [:label.bx--label.block (tr [:inspection/time-slot] [(inc i)])]
                               (butil/time-slot-string slot group-tz)])
                 slots)]])


(defn control-buttons [{:keys [tr editing? group-id dispatch-slots customer-slots no-workdays? use-superdomain-calendar?]}]
  (if editing?
    [:div
     (cc/button
       {:class-name "ml-4"
        :kind       :secondary
        :size       :field
        :on-click   #(>evt [::clear-editor])}
       (tr [:cancel]))
     [ui/modal-confirmation-button
      {:id                  "save-time-slots"
       :tr                  tr
       :trigger-button-opts {:kind       :primary
                             :class-name "ml-4"
                             :disabled   (or (not (<sub [::slots-edited?]))
                                             (not (<sub [::slots-valid?])))
                             :size       :field}
       :trigger-button-text (tr [:save])
       :on-yes-click        #(>evt [::save-time-slots group-id])}
      (tr [:inspection/save-time-slots-confirm])]]
    (cc/button
      {:class-name "ml-4"
       :disabled   (true? (or no-workdays? use-superdomain-calendar?))
       :on-click   (fn [_]
                     (>evt [::set-editor-value
                            :availability/time-slots
                            dispatch-slots])
                     (when (seq customer-slots)
                       (>evt [::set-editor-value
                              :availability/customer-time-slots
                              customer-slots])
                       (>evt [::set-editor-value ::separate-cust-slots? true])))
       :size       :field}
      (tr [:edit]))))


(defn time-slots [availability {:keys [tr]}]
  (r/with-let []
    (let [editing?                  (<sub [::editing?])
          dispatch-slots            (<sub [::dispatch-time-slots])
          customer-slots            (<sub [::customer-time-slots])
          group-id                  (<sub [::gas/group-id])
          group-tz                  (<sub [::gas/group-tz])
          ctx                       (util/mmap group-id group-tz tr)
          unified-slots?            (if-some [v (<sub [::editor-value ::separate-cust-slots?])]
                                      (not v)
                                      (empty? customer-slots))
          no-workdays?              (-> availability
                                        booking-model/workdays-from-availability
                                        empty?)
          superdomain-calendar-ff?  (ff/enabled? :feature-flag.id/superdomain-working-day-calendar)
          use-superdomain-calendar? (<sub [::gas/use-superdomain-calendar?])]
      [acommon/form (when-not superdomain-calendar-ff?
                      {:title       (tr [:inspection/time-slots])
                       :legend-text (tr [:inspection/time-slots-legend])})
       (when no-workdays?
         [ui/warning (tr [:inspection/working-days-time-slots-note])])
       [:div.flex.justify-start
        [:div.flex-0 {:style {:width "500px"}}
         [:h4.my-2 (tr [:inspection/time-slots-dispatching])]
         (if editing?
           [time-slots-editor ctx :availability/time-slots]
           [time-slot-list ctx dispatch-slots])
         [:div.mt-4
          (if editing?
            [:div
             (cc/checkbox {:label-text (tr [:inspection/time-slots-unified-label])
                           :id         "time-slots-unified"
                           :checked    unified-slots?
                           :on-change  #(>evt [::set-editor-value ::separate-cust-slots? (not %)])})
             (when-not unified-slots?
               [:<>
                [:h4.my-2 (tr [:inspection/time-slots-requests])]
                [time-slots-editor ctx :availability/customer-time-slots]])]
            [:div
             (if (empty? customer-slots)
               (tr [:inspection/time-slots-unified-label])
               [:<>
                [:h4.my-2 (tr [:inspection/time-slots-requests])]
                [time-slot-list ctx customer-slots]])])]]
        [:div
         [control-buttons (util/mmap tr editing? group-id dispatch-slots customer-slots no-workdays? use-superdomain-calendar?)]]]])
    (finally
      (>evt [::clear-editor]))))


(defn view [opts]
  (let [availability (<sub [::gas/group-availability])]
    ^{:key (str (:db/id availability) "-time-slots")}
    [time-slots availability opts]))
